export const TRAINING_CONTROL_QUALITY_RECORD = { code: 'RQ18.1', revision: 'REV.07' } as const;
